import { Box, Button, Card, CardActions, CardContent, makeStyles, TextField, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { email, Notification, usePermissions, useRedirect, userLogin } from "react-admin";
import { useDispatch } from "react-redux";

import iconsLeft from "../../assets/icons-left.png";
import iconsRight from "../../assets/icons-right.png";
import Logo from "../../assets/logo.svg";
import PasswordIcon from "../../assets/password.svg";
import UsernameIcon from "../../assets/username.svg";
import { useGetWebViewFcmToken } from "../../shared/BaseNotificationList";

const useStyles = makeStyles((theme) => ({
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: "100vh",
    overflow: "hidden",
    background: theme.palette.background.paper,
  },
  logo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 200,
    width: 250,

    "& img": {
      width: "100%",
    },
  },
  icons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",

    "& img": {
      width: "95%",
      height: "100%",
      objectFit: "cover",
    },
  },
  card: {
    minWidth: 300,
    maxWidth: 375,
    width: 350,
    height: 300,
    borderRadius: 30,
    padding: theme.spacing(1),
    boxShadow: theme.shadows[0],
    background: "linear-gradient(40deg, #59D885, #00C5FD)",
    overflow: "initial",
  },
  cardContent: {
    padding: theme.spacing(1),
  },
  title: {
    color: theme.palette.grey[100],
    fontSize: 20,
    textAlign: "center",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
  },
  textField: {
    backgroundColor: theme.palette.background.default,
    borderRadius: 10,
    "& .MuiInputBase-input, & fieldset": {
      borderRadius: 10,
      borderWidth: 0,
    },
    "& .MuiInputBase-input": {
      fontSize: 12,
      height: 16,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#587190 !important",
    },
  },
  textFieldIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 25,
    width: 25,
    marginRight: theme.spacing(1.5),

    "& img": {
      width: "100%",
    },
  },
  button: {
    background: "linear-gradient(60deg, #587190, #00C5FD)",
    color: theme.palette.background.default,
    height: 32,
    width: 150,
    fontSize: 12,
    marginTop: theme.spacing(2),

    "&.Mui-disabled": {
      background: "transparent",
      color: theme.palette.grey[300],
    },

    "&.MuiButton-contained:hover": {
      backgroundColor: "#59D885",
    },
  },
}));

const isValid = (emailValue: string | null, password: string | null) => {
  if (!emailValue || !password) return;
  if (email()(emailValue, {})) return;
  return true;
};

const Login = () => {
  const classes = useStyles();
  const [emailValue, setEmailValue] = useState<string | null>(null);
  const [password, setPassword] = useState<string | null>(null);
  const dispatch = useDispatch();
  const permissions = usePermissions();
  const redirect = useRedirect();

  useGetWebViewFcmToken();

  useEffect(() => {
    if (permissions.loaded && permissions.permissions) redirect("/");
  }, [permissions]);

  return (
    <Box className={classes.main}>
      <Box className={classes.logo}>
        <img src={Logo} alt="Sporting" />
      </Box>

      <Box display="flex" alignItems="center" justifyContent="center" width="100%">
        <Box className={classes.icons}>
          <img src={iconsLeft} alt="left icons" />
        </Box>

        <Card className={classes.card}>
          <form
            onSubmit={(e) => {
              e.stopPropagation();
              e.preventDefault();
              dispatch(
                userLogin(
                  {
                    username: emailValue,
                    password: password,
                  },
                  "/"
                )
              );
            }}
          >
            <CardContent className={classes.cardContent}>
              <Box display="flex" flexDirection="column">
                <Typography className={classes.title}>User Login</Typography>

                <Box mt={1}>
                  <TextField
                    id="email"
                    placeholder="Email"
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    className={classes.textField}
                    value={emailValue}
                    autoFocus
                    onChange={(e) => setEmailValue(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <Box className={classes.textFieldIcon}>
                          <img src={UsernameIcon} alt="username" />
                        </Box>
                      ),
                    }}
                  />
                  <TextField
                    id="password"
                    placeholder="Password"
                    variant="outlined"
                    type="password"
                    fullWidth
                    margin="dense"
                    className={classes.textField}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <Box className={classes.textFieldIcon}>
                          <img src={PasswordIcon} alt="password" />
                        </Box>
                      ),
                    }}
                  />
                </Box>
              </Box>
            </CardContent>
            <CardActions>
              <Box width="100%" mt={1} display="flex" justifyContent="center">
                <Button
                  size="small"
                  variant="contained"
                  type="submit"
                  disabled={!isValid(emailValue, password)}
                  className={classes.button}
                >
                  Sign in
                </Button>
              </Box>
            </CardActions>
          </form>
        </Card>

        <Box className={classes.icons}>
          <img src={iconsRight} alt="left icons" />
        </Box>
      </Box>
      <Notification />
    </Box>
  );
};

export default Login;
